import { render, staticRenderFns } from "./CertificateCreate.vue?vue&type=template&id=49152dd8&scoped=true&"
import script from "./CertificateCreate.vue?vue&type=script&lang=js&"
export * from "./CertificateCreate.vue?vue&type=script&lang=js&"
import style0 from "./CertificateCreate.vue?vue&type=style&index=0&id=49152dd8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49152dd8",
  null
  
)

export default component.exports